import React from 'react'
import {Loading} from '@therms/atalaya'
import {
  EventListCard,
  NoResults,
  RPCDocs,
  useEvents,
  useLocationContext,
  useRPCServerEventHandler,
} from '@therms/react-modules'

interface RecentlyClosedEventsListProps {
  activityTypeIds?: string[]
  dateTimeRange: {start?: string; end?: string}
  eventTypeIds?: string[]
  locationId?: string
  onClickEvent?: (event: RPCDocs.Events.GetEventsList.v1.Event) => void
  searchText?: string
  userIdsAssigned?: string[]
}

function RecentlyClosedEventsList({
  activityTypeIds,
  dateTimeRange,
  eventTypeIds,
  locationId,
  onClickEvent,
  searchText,
  userIdsAssigned,
}: RecentlyClosedEventsListProps) {
  const locationCtx = useLocationContext()

  const {data, loading, refresh} = useEvents({
    activityTypeIdFilter: activityTypeIds?.length ? activityTypeIds : undefined,
    assignedUserIdFilter: userIdsAssigned,
    eventTypeIds: eventTypeIds?.length ? eventTypeIds : undefined,
    fromDate: dateTimeRange?.start,
    locationId: locationCtx?.locationId ?? locationId,
    pagination: {limit: 15, skip: 0},
    searchText,
    stateFilter: [RPCDocs.Events.GetEventsList.v1.StateFilter.Closed],
    toDate: dateTimeRange?.end,
  })

  useRPCServerEventHandler('EventCreated', refresh)
  useRPCServerEventHandler('EventDeleted', refresh)
  useRPCServerEventHandler('EventDetailsUpdated', refresh)
  useRPCServerEventHandler('EventStateUpdated', refresh)

  return (
    <div className="gap-y-sm flex flex-col">
      {loading && !data?.events?.length && (
        <div className="flex justify-center">
          <Loading size="base" />
        </div>
      )}

      {data?.events?.length ? (
        <div className="gap-y-xs flex flex-col">
          {data?.events?.map((event) => (
            <EventListCard
              event={event}
              key={event.id}
              onClick={onClickEvent}
            />
          ))}
        </div>
      ) : (
        <NoResults text="No Closed Events" />
      )}
    </div>
  )
}

export {RecentlyClosedEventsList}
